import React, { useState } from 'react'

// components
import SideViewModal from '../../../../components/modals/SideViewModal/SideViewModal.component'

//collections
import AddPurchaseOrder from '../AddPurchaseOrder.form'

// queries
import { useMutation } from '@apollo/client'
import { CREATE_EQUIPMENT_PURCHASE_ORDER } from '../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.mutations'
import { GET_ALL_PURCHASE_ORDERS_WITH_FULL_DETAIL } from '../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries'

// utils
import { calculateTotalCents, cleanItems } from './CreatePurchaseOrder.form.controller.utils'
import { validate } from '../../../../shared/utility.js'

const validationSchema = {
    vendorName: {
        type: 'input',
        validation: {
            required: true
        }
    },
    number: {
        type: 'input',
        validation: {
            required: true
        }
    },
    orderDate: {
        type: 'date',
        validation: {
            required: true,
            isDate: true
        }
    },
    job: {
        type: 'input',
        validation: {
            isNumeric: true
        }
    },
    items: {
        type: 'list',
        fields: {
            id: {
                type: 'number',
                validation: {
                    isNumeric: true
                }
            },
            quantity: {
                type: 'input',
                validation: {
                    required: true,
                    isNumeric: true
                }
            },
            price: {
                type: 'input',
                validation: {
                    required: true,
                    isCurrency: true
                }
            }
        }
    }
}

export default function CreatePurchaseOrderFormController({ visible, closeForm }) {
    const [createPurchaseOrder, ] = useMutation(CREATE_EQUIPMENT_PURCHASE_ORDER)
    const [errors, setErrors] = useState({ items: []})

    // handle the form submission
    const handleSubmit = (formData) => {

        let submitData = {...formData}

        const { isValid, errors } = validate(submitData, validationSchema)

        submitData['totalCents'] = calculateTotalCents(formData.items)
        submitData['items'] = cleanItems(formData.items)
        submitData['orderDate'] = formData.orderDate.format("YYYY-MM-DD")

        if(isValid) {
            
            createPurchaseOrder({ variables: {...submitData}, refetchQueries:[GET_ALL_PURCHASE_ORDERS_WITH_FULL_DETAIL]}).catch(e => {
                console.error(e)
            }).then(result => {
                if(result) {
                    setErrors({ items: []})
                    closeForm()
                }
            })
        } else {
            setErrors(errors)
        }
    }

    if(visible) {
        const variants = [
            {
                name: 'New Purchase Order',
                component: <AddPurchaseOrder />,
                stages: 1
            }
        ]

        return (<SideViewModal 
            show={visible} 
            submitText='Add Purchase Order'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({ items: [] })
                closeForm()
            }} 
            title='New Purchase Order'
            variants={variants}   
            errors={errors} 
        />)
    }

    return null

}